import { BookableServiceData, ProductConsumptionMoment } from '@mews-commander/data-access';
import { EnumSelectField, SelectField } from '@mews-commander/form';
import { ContentSection, createOption } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Stack, StackItem } from '@optimus-web/core';
import { ProductChargingMode } from '@mews/enums';
import { useLocalizeChargingMode } from '../../../components/localization/LocalizedChargingMode';

interface Props {
    bookableServiceData: BookableServiceData;
}
export const AllowancePostingSection = ({ bookableServiceData }: Props) => {
    const localizeChargingMode = useLocalizeChargingMode(bookableServiceData);

    return (
        <ContentSection
            title={lt('Charging')}
            spacing="300"
            contentSpacing="200"
            description={lt('AllowanceFormChargingSectionDescription')}
        >
            <Stack spacing="100" fill>
                <StackItem grow>
                    <SelectField
                        required
                        name="pricing.charging"
                        label={lt('Frequency')}
                        options={[
                            createOption({
                                value: ProductChargingMode.Once,
                                label: localizeChargingMode(ProductChargingMode.Once),
                            }),
                        ]}
                    />
                </StackItem>
                <StackItem minWidth="50%">
                    <EnumSelectField
                        enumClass={ProductConsumptionMoment}
                        enumPrefix="ProductConsumptionMoment"
                        enabledValues={[ProductConsumptionMoment.ServiceOrderStart]}
                        required
                        name="consumptionMoment"
                        label={lt('Timing')}
                    />
                </StackItem>
            </Stack>
        </ContentSection>
    );
};
